export default __webpack_public_path__ + "static/download-7a85cd225735f8cc388822dc7b5255ad.svg";